import React, {Linking} from 'react';

//import './StoreButton.css'
import styles from './StoreButton.module.css'

export const STORE_TYPE_APPLE = "apple";
export const STORE_TYPE_GOOGLE = "google";

const storeButton = (props) => {

    let logo = null;
    let [t1, t2] = [null, null];
    if (props.store === STORE_TYPE_GOOGLE) {
        logo = <svg className={styles.image} viewBox="0 0 22 24" fill="none">
            <path d="M14.2748 10.9854L3.77256 0.609883L17.1345 8.16779L14.2748 10.9854ZM1.03241 0C0.413421 0.31882 0 0.900197 0 1.65486V22.3451C0 23.0998 0.414182 23.6812 1.03241 24L13.2432 11.9974L1.03241 0ZM21.2649 10.5773L18.4623 8.97871L15.3362 12.0026L18.4623 15.0265L21.322 13.4279C22.1785 12.758 22.1785 11.248 21.2649 10.5773V10.5773ZM3.77332 23.3961L17.1353 15.8382L14.2756 13.0206L3.77332 23.3961Z" fill="white" fillOpacity="0.87" />
        </svg>;
        t1 = "Get it on";
        t2 = "Google Play"
    }
    else if (props.store === STORE_TYPE_APPLE) {
        logo = <svg className={styles.image}  width="40" height="47" viewBox="0 0 40 47" fill="none">
            <path d="M38.7515 36.6273C38.0667 38.2235 37.2208 39.7456 36.2267 41.1699C34.8988 43.0665 33.8083 44.3771 32.9725 45.1066C31.6743 46.2985 30.2796 46.9118 28.7885 46.9464C27.7203 46.9464 26.4294 46.6422 24.926 46.024C23.4176 45.4083 22.0328 45.1066 20.7642 45.1066C19.4363 45.1066 18.012 45.4083 16.4863 46.024C14.963 46.6422 13.7315 46.9662 12.7894 46.9958C11.3626 47.0577 9.93577 46.4296 8.5139 45.1066C7.60638 44.3153 6.47136 42.9553 5.10884 41.0314C3.64987 38.9814 2.45056 36.5952 1.51089 33.8825C0.504454 30.9473 0 28.1085 0 25.3587C0 22.2108 0.680025 19.4932 2.04255 17.2182C3.07309 15.4315 4.54639 13.9403 6.32052 12.8883C8.06995 11.839 10.067 11.274 12.1069 11.2513C13.2444 11.2513 14.7355 11.6024 16.5827 12.2948C18.4299 12.9872 19.6168 13.3384 20.1337 13.3384C20.5244 13.3384 21.8374 12.9254 24.0729 12.1069C26.1822 11.3477 27.9626 11.0337 29.4216 11.1573C33.3781 11.4763 36.3479 13.0342 38.3237 15.8433C34.7876 17.9873 33.0393 20.9868 33.0739 24.837C33.1036 27.8365 34.1941 30.3315 36.3306 32.3123C37.2751 33.2162 38.3772 33.9394 39.5823 34.4463C39.3202 35.2055 39.0433 35.93 38.7515 36.6273V36.6273ZM29.6837 0.942143C29.6837 3.29132 28.8231 5.48718 27.1144 7.51736C25.0471 9.93082 22.5496 11.328 19.8419 11.1079C19.8064 10.8125 19.7891 10.5152 19.7899 10.2177C19.7899 7.95999 20.7692 5.54652 22.5175 3.57074C23.3879 2.57173 24.4957 1.73839 25.8384 1.07567C27.1787 0.422851 28.4448 0.0618204 29.6367 0C29.6688 0.31652 29.6837 0.630568 29.6837 0.942143V0.942143Z" fill="white" fillOpacity="0.87" />
        </svg>;
        t1 = "Download on the";
        t2 = "App Store"
    }

    return (
        <div className={styles.container} onClick={() => window.open(props.url, '_blank')}>
            {logo}
            <div className={styles.innerContainer}>
                <p className={styles.text1}>{t1}</p>
                <p className={styles.text2}>{t2}</p>
            </div>
        </div>
    );
}

export default storeButton;